module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bb1ded49c939297ed7425c8534f537d8.png";